import { useState } from "react";
import StationeryEditor from "./StationeryEditor";
import MenuEditor from "./MenuEditor";
import CeremonyEditor from "./CeremonyEditor";

export default function Invitations() {
  const [mode, setMode] = useState("stationery");
  const TABS = [["stationery", "Faire-part & Papeterie"], ["menu", "Menu"], ["ceremony", "Programme de cérémonie"]];
  return (
    <div>
      <div className="flex gap-2 mb-6 flex-wrap">
        {TABS.map(([k, l]) => (
          <button key={k} onClick={() => setMode(k)} data-testid={`stationery-tab-${k}`}
            className={`px-4 py-1.5 rounded-full text-sm border ${mode === k ? "bg-stone-900 text-white" : "bg-white"}`}>{l}</button>
        ))}
      </div>
      {mode === "stationery" && <StationeryEditor />}
      {mode === "menu" && <MenuEditor />}
      {mode === "ceremony" && <CeremonyEditor />}
    </div>
  );
}
